module.exports = __webpack_public_path__ + "static/media/health-program_p2_2.b563f253.png";